/**
 *
 * 方案汇报 - 模型压平 1.0
 *
 * 功能点:倾斜摄影根据点集进行压平操作.
 * 场景:方案汇报
 *
 */
import Vue from "@/main";
import { getExcavationDetail } from "../../../api/api";
import { modelFlatData } from "@/components/tables/program/static-data.js";

let flat = null;
let currentModelId;

function selectModel(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (!tilesetLayer) {
    Vue.$alert("请选择要压平的模型。", "友情提示", {
      confirmButtonText: "确定",
      type: "warning",
      callback: (action) => {},
    });
    return false;
  }
  if (currentModelId !== modelId && flat) {
    flat.clear();
  }
  currentModelId = modelId;
  flat = tilesetLayer.flat;
  return true;
}

function removeFlat() {
  if (flat) {
    flat.clear();
  }
}

function addFlat(id) {
  let positions = [];
  const params = {
    Id: modelFlatData[id].excavationId,
  };
  getExcavationDetail(params).then((res) => {
    const data = res.data.data;
    let excavationDetails = JSON.parse(data.excavationDetails);
    excavationDetails.excavationDetails.forEach((i) => {
      positions.push(i);
    });
    let polygonArea = new mars3d.graphic.PolygonEntity({
      positions: positions,
    });
    if (polygonArea) {
      flat.addArea(polygonArea.positionsShow, {
        height: modelFlatData[id].height,
      });
    }
  });
}

export function modelExcavationFlating(type, id) {
  if (type == "remove") {
    removeFlat();
    return;
  }

  if (!modelFlatData[id] || !selectModel(modelFlatData[id].modelId)) {
    return;
  }
  if (type == "add") {
    addFlat(id);
  }
}

export function adjustHeight(height) {
  if (flat) {
    flat.updateHeight(height);
  }
}
